import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table } from 'antd'

import './inductionManage.less'
class InductioPackage extends Component {
  state = {
    columns: [{
      title: '学科名称',
      dataIndex: 'des',
      align: 'center',
      key: 'des',
    },
	  {
      title: '操作',
      align: 'center',
      render: (row) => {
        return (
          // <Button type="link" onClick={() => {this.props.history.push('/inductionManageDetails',{subjectId: row.subjectId})}}>查看资料</Button>
          <Button type="link" onClick={() => {this.handleKnow('edit',row)}}>编辑资料</Button>
        )
      }
    }],
    dataSource: [],
    total: 0,
    current: 1,
    size: 10
  }
  componentDidMount() {
    this.getTestQuestionSubjectList()
  }
  getTestQuestionSubjectList() {
    axios.get('testQuestionc/getTestQuestionSubjectList').then(res => {
      if (+res.data.code === 200) {
        this.setState({dataSource: res.data.data})
      }
    })
  }
  sizeChange = (current,size) => {
    this.setState({size: size},() =>{
      this.InitPay()
    })
  }
  pageChange = (current) => {
    this.setState({current: current},() =>{
      this.InitPay()
    })
  }
  handleKnow(name, obj) {
    this.props.history.push('/inductionManageDetails',{typeTitel: name,subjectId: obj.content})
  }
  InitPay() {
    console.log(this.state.current, this.state.size)
  }
  render() {
    let {dataSource, columns} = this.state
    return (
      <div className="zip-list">
        <span className="header-name">入门测管理</span>
				<Divider />
        <div>
          <Table pagination={false} rowKey={record => record.id} dataSource={dataSource} columns={columns} />
          {/* <Pagination className="table-pagination" total={total} showSizeChanger defaultCurrent={current} defaultPageSize={size} showQuickJumper pageSizeOptions={['10','20','50','100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} /> */}
        </div>
      </div>
    )
  }
}
export default InductioPackage